import type { Dispatch } from 'redux'
import type { ConfigState } from 'client/reducers/configReducer'
import { klubbleAPI } from 'client/api/common'
import { rethrowError } from 'client/utilities/error'
import type {
  ConfigAction,
} from './types'

export const SET_CONFIG = 'SET_CONFIG'

export const fetchConfig = (abortController: AbortController) => async (dispatch: Dispatch<ConfigAction>) => {
  try {
    const res = await klubbleAPI.get<ConfigState>('/getconfig', {
      signal: abortController.signal,
    })
    const {
      isLightTrialEnabled,
      isFreeTrialMode,
      freeTrialDays,
      lightTrialDays,
      isExtendedTrialMode,
      extendedTrialDays,
      entity,
    } = res.data

    dispatch({
      type: SET_CONFIG,
      payload: {
        isLightTrialEnabled,
        isFreeTrialMode,
        freeTrialDays,
        lightTrialDays,
        isExtendedTrialMode,
        extendedTrialDays,
        entity,
      },
    })
  } catch (e) {
    rethrowError(e, 'Error getting config')
  }
}
